import React, { useContext } from "react";
import Logo from "../CourseImages/Logo.png";
import "./StudentNav.css";
import { Link, useLocation } from "react-router-dom";
// import scourses from '../../assets/sscourses.png';
import scalendar from "../../assets/scalendar.png";
import srewards from "../../assets/srewards.png";
import seditprofile from "../../assets/seditprofile.png";
import slogout from "../../assets/slogout.png";
import shome from "../../assets/homeicon.png";
import { UserContext } from "../UserContext";

const StudentNav = ({ onLogout }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { logout } = useContext(UserContext);

  // Check if current path is a course-related page
  const isCoursePage = currentPath.includes('/StudentDashboard/') || 
                      currentPath.includes('/MyProgress/') || 
                      currentPath.includes('/ActivitiesAndProjects/') || 
                      currentPath.includes('/ActivityProject/') || 
                      currentPath.includes('/AttendClass/') ||
                      currentPath === '/StudentCourses';

  return (
    <>
      {/* Sidebar for large screens */}
      <div className="studentnav-sidebar">
        <img src={Logo} alt="Logo" className="studentnav-logo" />
        {/* {currentPath === "/calenderview" && (
          <div className="calendar-heading">Calender</div>
        )} */}
        <div className="studentnav-menu">
          <Link
            to="/"
            className={`studentnav-item${currentPath === "/" ? " active" : ""}`}
          >
            <img src={shome} alt="Home" className="studentnav-icon" />
            <span className="studentnav-text">Home</span>
          </Link>
          <Link
            to="/StudentCourses"
            className={`studentnav-item${
              isCoursePage ? " active" : ""
            }`}
          >
            <img src={scalendar} alt="Courses" className="studentnav-icon" />
            <span className="studentnav-text">Courses</span>
          </Link>
          <Link
            to="/calenderview"
            className={`studentnav-item${
              currentPath === "/calenderview" ? " active" : ""
            }`}
          >
            <img src={scalendar} alt="Calendar" className="studentnav-icon" />
            <span className="studentnav-text">Calendar</span>
          </Link>
          <Link
            to="/StudentReward"
            className={`studentnav-item${
              currentPath === "/StudentReward" ? " active" : ""
            }`}
          >
            <img src={srewards} alt="Rewards" className="studentnav-icon" />
            <span className="studentnav-text">Rewards</span>
          </Link>
          <Link
            to="/EditProfile"
            className={`studentnav-item${
              currentPath === "/EditProfile" ? " active" : ""
            }`}
          >
            <img
              src={seditprofile}
              alt="Edit Profile"
              className="studentnav-icon"
            />
            <span className="studentnav-text">Profile</span>
          </Link>
        </div>
        <div className="studentnav-logout">
          <button
            className="studentnav-item logout-btn"
            onClick={() => {
              console.log("Logout button clicked");
              if (onLogout) {
                onLogout(); // Use prop if provided (for backward compatibility)
              } else {
                logout(); // Use centralized logout function
              }
            }}
          >
            <img src={slogout} alt="Log Out" className="studentnav-icon" />
            <span className="studentnav-text">Log Out</span>
          </button>
        </div>
      </div>
      {/* Bottom nav for small screens */}
      <div className="studentnav-bottomnav">
        <Link
          to="/"
          className={`studentnav-bottomnav-item${
            currentPath === "/" ? " active" : ""
          }`}
        >
          <img src={shome} alt="Home" className="studentnav-bottomnav-icon" />
          <span>Home</span>
        </Link>
        <Link
          to="/StudentCourses"
          className={`studentnav-bottomnav-item${
            isCoursePage ? " active" : ""
          }`}
        >
          <img
            src={scalendar}
            alt="Courses"
            className="studentnav-bottomnav-icon"
          />
          <span>Courses</span>
        </Link>
        <Link
          to="/calenderview"
          className={`studentnav-bottomnav-item${
            currentPath === "/calenderview" ? " active" : ""
          }`}
        >
          <img
            src={scalendar}
            alt="Calendar"
            className="studentnav-bottomnav-icon"
          />
          <span>Calendar</span>
        </Link>
        <Link
          to="/StudentReward"
          className={`studentnav-bottomnav-item${
            currentPath === "/StudentReward" ? " active" : ""
          }`}
        >
          <img
            src={srewards}
            alt="Rewards"
            className="studentnav-bottomnav-icon"
          />
          <span>Rewards</span>
        </Link>
        <Link
          to="/EditProfile"
          className={`studentnav-bottomnav-item${
            currentPath === "/EditProfile" ? " active" : ""
          }`}
        >
          <img
            src={seditprofile}
            alt="Profile"
            className="studentnav-bottomnav-icon"
          />
          <span>Profile</span>
        </Link>
        <Link
          className="studentnav-bottomnav-item"
          onClick={() => {
            if (onLogout) {
              onLogout(); // Use prop if provided (for backward compatibility)
            } else {
              logout(); // Use centralized logout function
            }
          }}
        >
          <img
            src={slogout}
            alt="Log Out"
            className="studentnav-bottomnav-icon"

          />
          <span>Log Out</span>
        </Link>
      </div>
    </>
  );
};

export default StudentNav;
